<template>
  <div class="page-container" v-if="currentNews && currentNews.title">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p class="page-date" v-if="currentNews.date">{{ currentNews.date }}</p>
    <div class="content">
      <template v-for="(section, index) in contentSections" :key="index">
        <div class="content-section">
          <div class="text-block">
            <p v-html="section"></p>
          </div>
        </div>
        <div v-if="index === 0 && currentNews.other?.picture1?.url" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other.picture1.url">
            <p class="image-caption">{{ currentNews.other?.picture1?.caption }}</p>
          </div>
        </div>
        <div v-if="index === 2 && currentNews.other?.picture2?.url" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other.picture2.url">
            <p class="image-caption">{{ currentNews.other?.picture2?.caption }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();

const currentNews = computed(() => {
  const translationData = langStore.currentLang.startsWith('zh') ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  const newsItem = newsList.find((news: any) => news.id === 'quanchaodiancitixinjilu');
  return newsItem || {};
});

const contentSections = computed(() => {
  const content = (currentNews.value as any)?.content || '';
  return content ? content.split('---').filter((p: string) => p.trim()) : [];
});
</script>

<style scoped>
.page-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
}

.page-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
}

.content {
  line-height: 1.8;
  color: #444;
}

.content-section {
  margin-bottom: 20px;
}

.text-block p {
  margin-bottom: 15px;
  text-align: justify;
  font-size: 16px;
}

.image-section {
  text-align: center;
  margin: 30px 0;
}

.image-container {
  display: inline-block;
  max-width: 100%;
}

.image-container img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.image-caption {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
  font-style: italic;
}

@media (max-width: 768px) {
  .page-container {
    padding: 15px;
  }
  
  .page-title {
    font-size: 24px;
  }
  
  .text-block p {
    font-size: 15px;
  }
}
</style>